import React from "react";
import { useNavigate } from "react-router-dom";
import CabiMascot from "./CabiMascot";
import Button from "./Button";

// Shown after a guest ("Try it now") session has played its free sample
// games — the conversion moment the whole guest flow exists for.
export default function GuestSignupWall({ onClose }) {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(42,38,32,.55)" }}>
      <div className="bg-white rounded-sheet shadow-sheet p-8 max-w-sm w-full text-center relative">
        <button
          onClick={onClose}
          className="absolute end-4 top-4 text-faint hover:text-ink transition text-xl leading-none"
          aria-label="Close"
        >
          ✕
        </button>
        <div
          className="w-[100px] h-[100px] rounded-full mx-auto mb-3 flex items-center justify-center"
          style={{ background: "linear-gradient(150deg,#FFB47A,#EE5F2B)" }}
        >
          <CabiMascot mood="celebrating" size={64} />
        </div>
        <h2 className="font-display font-semibold text-xl text-ink mb-2">Having fun? 🎉</h2>
        <p className="text-muted font-body font-semibold text-sm mb-6">
          Sign up free to keep playing, save your progress, and unlock every game —
          no credit card needed for your 14-day trial.
        </p>
        <Button onClick={() => navigate("/kids/signup")} className="w-full">
          Create Free Account 🚀
        </Button>
        <button onClick={onClose} className="w-full mt-3 text-center text-faint font-body font-semibold text-sm hover:text-muted transition">
          Maybe later
        </button>
      </div>
    </div>
  );
}
